import React from "react";
import CardInput from "../../components/CardInput.js";
import { callAPI } from "../../utils.js";
import {
  buildPowerTranzRequest,
  getPowerTranzCreateTokenUrl,
  getPowerTranzRedirect,
  loadPowerTranzRedirect,
} from "./PowerTranz.utils.js";

const getErrorMessage = (error) =>
  error?.response?.data?.response?.message ??
  error?.response?.data?.message ??
  error?.message ??
  "Unable to start PowerTranz verification.";

export default function PowerTranz(props) {
  const { alert, setIsLoading } = props;

  const onSubmit = async (formData) => {
    setIsLoading(true);
    try {
      const response = await callAPI(
        getPowerTranzCreateTokenUrl(
          process.env.REACT_APP_WEBHOOK_API_ENDPOINT,
          props.userType
        ),
        "POST",
        buildPowerTranzRequest(formData, props)
      );

      const nextStep = getPowerTranzRedirect(response);
      if (nextStep.returnCode !== 200) {
        alert(nextStep.message ?? `PowerTranz error: ${nextStep.returnCode}`);
        return;
      }
      if (nextStep.html || nextStep.url) {
        loadPowerTranzRedirect(nextStep);
        return;
      }

      alert("PowerTranz did not return 3DS redirect data.");
    } catch (error) {
      alert(getErrorMessage(error));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container">
      <CardInput onSubmit={onSubmit} configGateway={props} />
    </div>
  );
}
